import { TYPES } from "./payrate_setting.type";

const INITIAL_STATE = {
  settings: null,
  loading: false,
};

const payrateSettingReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TYPES.SNAP_PAYRATE_SETTINGS_REQUEST:
      return { ...state, loading: true };
    case TYPES.SNAP_PAYRATE_SETTINGS_SUCCESS:
      return { ...state, loading: false, settings: action.payload };
    case TYPES.SAVE_PAYRATE_SETTING_SUCCESS: {
      const { staffId, data } = action.payload;
      return {
        ...state,
        settings: { ...state.settings, [staffId]: data },
      };
    }
    default:
      return state;
  }
};

export default payrateSettingReducer;
